export default function capitalizeFirstLetters(str: string) {
  if (str.length === 0) return "";
  const arr = str.split(" ");
  // loop through each element of the array and capitalize the first letter.
  for (let i = 0; i < arr.length; i += 1) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  }
  // Join all the elements of the array back into a string
  return arr.join(" ");
}
